import IApiResponse from '@/types/api-response'
import axios from '@/utils/axios-instance'

export const getUserInfo = async (): Promise<IApiResponse<any>> => {
	const { data } = await axios.get<IApiResponse<any>>('/api/user-info')
	return data
}

export const getUsers = async (params: {
	[key: string]: any
}): Promise<IApiResponse<any>> => {
	const { data } = await axios.get<IApiResponse<any>>('/api/user', { params })
	return data
}

export const updateUser = async (params: {
	[key: string]: any
}): Promise<IApiResponse<any>> => {
	const { data } = await axios.put<IApiResponse<any>>('/api/user', params)
	return data
}

export const removeUser = async (params: {
	[key: string]: any
}): Promise<IApiResponse<any>> => {
	const { data } = await axios.delete<IApiResponse<any>>('/api/user', {
		params,
	})
	return data
}
